import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";

const faqData = [
  {
    title: "Do I need to book an appointment before visiting the studio?",
    description:
      "Yes. Consultations at Sonam Label are by appointment only, in-studio at Vasant Vihar, Dehradun, or over video for brides who cannot visit in person. This allows Sonam and her team to give every bride focused, unhurried attention.",
  },
  {
    title: "Can I book a virtual consultation if I am not based in Dehradun?",
    description:
      "Yes. Video consultations are available for brides and families anywhere, so distance need not delay the start of your bridal journey.",
  },
  {
    title: "What happens after I submit an enquiry?",
    description:
      "Once you submit the form, the team will get in touch to understand your requirements and confirm a convenient date and time for your consultation.",
  },
  {
    title: "Can I discuss ensembles for multiple functions in one consultation?",
    description:
      "Yes. Whether it is Haldi, Mehandi, Sangeet, Wedding, or Festive wear, the consultation can cover your entire celebration wardrobe in one conversation.",
  },
  {
    title: "How far in advance should I book my consultation?",
    description:
      "Given the bespoke and limited-availability nature of the studio's work, it is best to book your consultation as early as possible once your wedding date is set.",
  },
  {
    title: "Is customisation available for every ensemble?",
    description:
      "Yes. Every piece at Sonam Label is shaped around the individual bride, her story, and the occasion she is dressing for.",
  },
];

export default function Faq() {
  const [activeKey, setActiveKey] = useState(null);
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="process-head">
              <h2 className="heading">FAQs</h2>
            </div>
          </div>

          <div className="col-lg-10">
            <Accordion activeKey={activeKey} className="service-accord">
              {faqData.map((item, index) => (
                <Card key={index} className={activeKey === String(index) ? "active" : ""}>
                  <Card.Header>
                    <Accordion.Item eventKey={String(index)}>
                      <Accordion.Header as="span" onClick={() => handleToggle(String(index))}>
                        {item.title}
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>{item.description}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card.Header>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
